import { useSelector } from 'react-redux';
import { PapiUser } from '@wix/da-papi-types';
import { getProfileOwnerUser } from '../../client/selectors/users';

export const useProfileOwnerUser = (): PapiUser => useSelector(getProfileOwnerUser);

export default useProfileOwnerUser;
